import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { HamburgerIcon } from 'components/Icons';
import { useI18n } from 'components/I18n';
import { MENU_ICON_SIZE } from './navigationUtils';
import MenuDropdown, { DROPDOWN_TRIGGER_CLASS } from './MenuDropdown';
import TopNavigation from './TopNavigation';
import { Hamburger } from './Styles';

function VerticalMenu({
  shouldShowSignUp,
  visibleMenuItems,
  defaultMenuItem,
}) {
  const i18n = useI18n();
  const [menuExpanded, setMenuExpanded] = useState(false);

  const openMenu = () => setMenuExpanded(true);
  const closeMenu = () => setMenuExpanded(false);

  return (
    <MenuDropdown
      isOpen={menuExpanded}
      ariaHidden={!menuExpanded}
      role="menu"
      onOpen={openMenu}
      onClose={closeMenu}
      trigger={(
        <Hamburger
          className={DROPDOWN_TRIGGER_CLASS}
          data-cy="hamburger-menu"
          tabIndex="0"
          aria-label={i18n.formatText('aria.navigation.menuButton')}
        >
          <HamburgerIcon size={MENU_ICON_SIZE} />
        </Hamburger>
      )}
    >
      <TopNavigation
        position="vertical"
        dropdown
        shouldShowSignUp={shouldShowSignUp}
        visibleMenuItems={visibleMenuItems}
        defaultMenuItem={defaultMenuItem}
        onItemClick={closeMenu}
      />
    </MenuDropdown>
  );
}

VerticalMenu.propTypes = {
  shouldShowSignUp: PropTypes.bool,
  visibleMenuItems: PropTypes.array.isRequired,
  defaultMenuItem: PropTypes.object,
};

export default React.memo(VerticalMenu);

